import React from 'react';
import set from 'lodash/fp/set';
import omit from 'lodash/fp/omit';
import { getLocale, toolFormAttr, toolCollapseAttr } from '@utils/util';
import { SimpleForm as Form, Collapse } from '@whalecloud/fdx';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';

const { Panel } = Collapse;

const RemoteSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { componentSettings = {} } = {} } = element;

  const { url = '', parameter = "" } = componentSettings;
  const initialValues = { url, parameter };
  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      let newElement = element;
      const propName = `data.componentSettings.${key}`;
      const value = Object.prototype.hasOwnProperty.call(obj[key], 'value') ? obj[key].value : obj[key];
      if (value) {
        newElement = set(propName, value, newElement);
      } else {
        newElement = omit(propName, newElement);
      }
      updateElement({
        element: newElement,
      });
    });
  };

  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        <CommonItemSettings formLabelHide placeholderHide allowClearHide defaultValueHide disabledHide requiredHide />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_REMOTE_URL']} name="url">
            <CustomInput />
          </Form.Item>
          <Form.Item label={messages['REMOTE_COMPONENT_PARAMTERS']} name="parameter">
            <CustomInput />
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  );
};

export default RemoteSettings;
